import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsSubject = [
  { title: 'Kurzbeschreibung', name: 'abbreviation' },
  { title: 'Beschreibung', name: 'description' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultSubject = {
  description: '', abbreviation: '',
};

const subjectValidationSchema = Yup.object().shape({
  description: Yup.string()
    .nullable(true)
    .max(50, 'Darf maximal 50 Zeichen lang sein.'),
  abbreviation: Yup.string()
    .max(10, 'Muss zwischen 1 und 10 Zeichen lang sein.')
    .matches(/^\S*$/, 'Keine Leerzeichen erlaubt')
    .required('Bitte geben Sie eine Kurzbeschreibung ein.'),
});

const SubjectOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [subject, setSubject] = useState({
    ...defaultSubject,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Fach | Stammdaten';
  }, []);

  useEffect(() => {
    if (subject._links !== undefined) {
      setSelfLink(subject._links.self.href);
    }

    // sets formik values
    if (formikRef.current && subject !== formikRef.current.values) {
      formikRef.current.setValues(subject);
    }
  }, [subject]);

  return (
    <div className="container-fluid">
      <ButtonCard title="Fach" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Fach"
          setEntity={setSubject}
          defaultEntity={defaultSubject}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(

            <Formik
              innerRef={formikRef}
              initialValues={subject}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.SUBJECTS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={subjectValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="subject-group">
                      <InputField
                        value={values.abbreviation}
                        handleChange={handleChange}
                        touched={touched.abbreviation}
                        errorDescription={errors.abbreviation}
                        fieldName="abbreviation"
                        placeholder="Kurzbeschreibung*"
                        props={{ className: 'mb-2' }}
                      />
                      <InputField
                        value={values.description}
                        handleChange={handleChange}
                        touched={touched.description}
                        errorDescription={errors.description}
                        fieldName="description"
                        placeholder="Beschreibung"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          )}
        />
        <PagedTable
          entityName={Bivema.SUBJECTS}
          columns={columnsSubject}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setSubject}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default SubjectOverview;
